import { AutoFormFieldProps } from "@autoform/react";
import React, { useEffect, useState } from "react";
import { UrlInput } from "../../url-input";

export const URLField: React.FC<AutoFormFieldProps> = ({
  inputProps,
  error,
  id,
  control,
}) => {
  const { key, ...props } = inputProps;
  const [url, setUrl] = useState("");

  useEffect(() => {
    control.unregister(props.name);
  }, [url])

  return (
    <>
      <UrlInput
        className={error ? "border-destructive" : ""}
        value={url}
        onChange={e => setUrl(e.target.value)}
      />
      <input type="hidden" key={key} id={id} {...props} value={url} />
    </>
  );
};
